let tFn = null;
let localeRef = null;

export function setTranslator(translatorFn, locale) {
  tFn = translatorFn;
  localeRef = locale;
}

// Providing both $t and t due to issues with globals ($) in composition library
export function t(...args) {
  if (!tFn) throw new Error('Translator not set. Call setTranslator() in main.js');
  return tFn(...args);
}

export function $t(...args) {
  if (!tFn) throw new Error('Translator not set. Call setTranslator() in main.js');
  return tFn(...args);
}

export function $locale() {
  return typeof localeRef?.value !== 'undefined' ? localeRef.value : localeRef;
}
